export const SIKE_LEAVE = "SIKE_LEAVE";
export const WORK_LEAVE = "WORK_LEAVE";
export const MEDICAL_CLAIM_FORM = "MEDICAL_CLAIM_FORM";
export const OTHER = "OTHER";

export function list() {
    return [
       { label: 'Son arrêt maladie', value: SIKE_LEAVE },
       { label: 'Son arrêt de travail', value: WORK_LEAVE },
       { label: 'Sa feuille de soins', value: MEDICAL_CLAIM_FORM },
   ];
}


// WEBPACK FOOTER //
// ./src/views/Dashboardlive/SelectList/MissingDocuments.js